import {
  ADD_TRACK_TO_USER_PLAN_FAIL,
  ADD_TRACK_TO_USER_PLAN_START,
  ADD_TRACK_TO_USER_PLAN_SUCCESS,
  CLEAR_COLLECTION_TRACKS,
  CLEAR_HAS_REWARDS,
  DELETE_TRACK_FROM_STUDY_PLAN_FAIL,
  DELETE_TRACK_FROM_STUDY_PLAN_START,
  DELETE_TRACK_FROM_STUDY_PLAN_SUCCESS,
  GET_COLLECTION_TRACKS_FAIL,
  GET_COLLECTION_TRACKS_START,
  GET_COLLECTION_TRACKS_SUCCESS,
  GET_TRACK_BY_ID_FAIL,
  GET_TRACK_BY_ID_START,
  GET_TRACK_BY_ID_SUCCESS,
  GET_TRACK_REPORT_FAIL,
  GET_TRACK_REPORT_START,
  GET_TRACK_REPORT_SUCCESS,
  GET_TRACK_SECTIONS_BY_ID_FAIL,
  GET_TRACK_SECTIONS_BY_ID_START,
  GET_TRACK_SECTIONS_BY_ID_SUCCESS,
  GET_TRACKS_FAIL,
  GET_TRACKS_START,
  GET_TRACKS_STATUS_FAIL,
  GET_TRACKS_STATUS_START,
  GET_TRACKS_STATUS_SUCCESS,
  GET_TRACKS_SUCCESS,
  RESCHEDULE_USER_TRACK_FAIL,
  RESCHEDULE_USER_TRACK_START,
  RESCHEDULE_USER_TRACK_SUCCESS,
} from './constants';

import { API_URL } from '@shared/constants/config';
import { DELETE, GET, POST, PUT, REST_API } from '@shared/constants/rest-api';
import getQueryString from '@shared/utils/get-query-string';

const headers = {
  Accept: '*/*',
  'Content-Type': 'application/json',
};

const defaultToken = '';

export const getTracks = (userId, status, pageable, onSuccess, onError) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL}/user/topic/plan/track${getQueryString({ userId, status, ...pageable })}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  types: [GET_TRACKS_START, GET_TRACKS_SUCCESS, GET_TRACKS_FAIL],
  onSuccess,
  onError,
});

export const getTrackById = (trackId, ignoreTopics = true, onSuccess, onError) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL}/track/${trackId}${getQueryString({ ignoreTopics })}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  types: [GET_TRACK_BY_ID_START, GET_TRACK_BY_ID_SUCCESS, GET_TRACK_BY_ID_FAIL],
  onSuccess,
  onError,
});

export const getTrackSectionsById = (trackId, onSuccess, onError) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL}/track/${trackId}/section`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  types: [GET_TRACK_SECTIONS_BY_ID_START, GET_TRACK_SECTIONS_BY_ID_SUCCESS, GET_TRACK_SECTIONS_BY_ID_FAIL],
  onSuccess,
  onError,
});

export const getTracksStatus = (onSuccess, onError) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL}/track/study-plan-status`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  types: [GET_TRACKS_STATUS_START, GET_TRACKS_STATUS_SUCCESS, GET_TRACKS_STATUS_FAIL],
  onSuccess,
  onError,
});

export const trackAddToUserPlan = (params, onSuccess, onError) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL}/track/user/add`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: params,
  types: [ADD_TRACK_TO_USER_PLAN_START, ADD_TRACK_TO_USER_PLAN_SUCCESS, ADD_TRACK_TO_USER_PLAN_FAIL],
  onSuccess,
  onError,
});

export const getCollectionTracks = (params, page, sort, onSuccess, onError) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL}/track/user/trackPlan`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  params: {
    ...params,
    page,
    sort,
  },
  types: [GET_COLLECTION_TRACKS_START, GET_COLLECTION_TRACKS_SUCCESS, GET_COLLECTION_TRACKS_FAIL],
  sort,
  onSuccess,
  onError,
});

export const deleteTrackFromStudyPlan = (id, onSuccess, onError) => ({
  type: REST_API,
  method: DELETE,
  url: `${API_URL}/track/user/${id}`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  onSuccess,
  onError,
  types: [DELETE_TRACK_FROM_STUDY_PLAN_START, DELETE_TRACK_FROM_STUDY_PLAN_SUCCESS, DELETE_TRACK_FROM_STUDY_PLAN_FAIL],
});

export const rescheduleUserTrack = (params, onSuccess, onError) => ({
  type: REST_API,
  method: PUT,
  url: `${API_URL}/track/user/reschedule`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  body: params,
  types: [RESCHEDULE_USER_TRACK_START, RESCHEDULE_USER_TRACK_SUCCESS, RESCHEDULE_USER_TRACK_FAIL],
  onSuccess,
  onError,
});

export const getTrackReport = (trackId, onSuccess, onError) => ({
  type: REST_API,
  method: GET,
  url: `${API_URL}/track/${trackId}/statistics/export/me`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('authorizationToken') || defaultToken,
  },
  responseType: 'blob',
  onSuccess,
  onError,
  types: [GET_TRACK_REPORT_START, GET_TRACK_REPORT_SUCCESS, GET_TRACK_REPORT_FAIL],
  timeout: 600000,
  disableAutoAbort: true,
});

export const clearCollectionTracks = () => ({
  type: CLEAR_COLLECTION_TRACKS,
});

export const clearHasRewards = () => ({
  type: CLEAR_HAS_REWARDS,
});
